import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CashierResponse } from 'src/app/models/cashier.model';
import { CashierService } from 'src/app/services/cashier.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { User } from 'src/app/models/user.model';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';

@Component({
  selector: 'app-modal-cashier',
  templateUrl: './modal-cashier.component.html',
  styleUrls: ['./modal-cashier.component.scss']
})
export class ModalCashierComponent {
  users: User[] = [];
  @Input() newCashier = new CashierResponse();
  @Input() isCreating: boolean = true;
  loading = false;
  @Output() close = new EventEmitter<boolean>();
  warehouses: WarehouseResponse[] = [];

  constructor(
    private cashierService: CashierService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private roleService: RolesAndPermissionsService,
    private warehouseService: WarehouseService
  ) {
  }

  ngOnInit(): void {
    this.getUsers();
    this.getWarehouses();
  }

  getUsers() {
    this.roleService.getUsers(parseInt(this.authService.getCurrentCompanyId())).subscribe({
      next: (response: ResponseObject) => {
        this.users = response.data;
      },
      error: (error: any) => {
        this.toastService.error("No se pudo cargar los usuarios")
      }
    })
  }

  getWarehouses() {
    this.warehouseService.getWarehouses().subscribe(
      {
        next: (response: ResponseObject) => {
          this.warehouses = response.data as WarehouseResponse[];
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );
  }


  createCashier() {
    this.loading = true;
    if (this.newCashier.warehouse && this.newCashier.warehouse == "null") {
      this.newCashier.warehouse = null;
    }
    if (this.isCreating) {
      this.newCashier.amount = this.newCashier.amount ? this.newCashier.amount : 0;
      this.newCashier.amountForeign = this.newCashier.amountForeign ? this.newCashier.amountForeign : 0;
      this.cashierService.postCashier(this.newCashier).subscribe({
        next: (response: ResponseObject) => {
          console.log(response);
          this.toastService.success('Caja creada correctamente!');
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          if (error.status == 400) {
            this.toastService.error(error.error.message);
          } else {
            this.toastService.error("Error al guardar la caja");
          }
        }
      });
    } else {
      this.cashierService.updateCategory(this.newCashier).subscribe({
        next: (response: ResponseObject) => {
          console.log(response);
          this.toastService.success('Caja editada correctamente!');
          this.loading = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          if (error.status == 400) {
            this.toastService.error(error.error.message);
          } else {
            this.toastService.error("Error al editar la caja");
          }
        }
      });
    }
  }
}
